export let it = {
    success: 'Successo',
};